import { UtmSource } from '@packages/shared/core/user/entities';
import { ChannelAttributionStrategy } from './ChannelAttributionStrategy';

export class DirectChannelAttributionStrategy implements ChannelAttributionStrategy {
  getUtmTags() {
    return {
      utm_source: UtmSource.DIRECT,
    };
  }
}
